import { useEffect, useMemo } from 'react';
import { useQueryState } from 'nuqs';

import { dubClickIdQuery, referralQuery } from '@/queries';
import { useAuthStore } from '@/stores/auth';

const getCookieValue = (name: string): string => {
    const prefix = `${encodeURIComponent(name)}=`;
    const entry = document.cookie.split('; ').find((cookie) => cookie.startsWith(prefix));

    if (!entry) return '';

    try {
        return decodeURIComponent(entry.slice(prefix.length));
    } catch {
        return '';
    }
};

export const useReferralInvitation = () => {
    const [shortReferralCode] = useQueryState('r', referralQuery);
    const [referralCode] = useQueryState('referral', referralQuery);
    const [referralId] = useQueryState('referralId', referralQuery);
    const [referralLinkId] = useQueryState('referralLinkId', referralQuery);
    const [referralAlias] = useQueryState('ref', referralQuery);
    const [queryDubClickId] = useQueryState('dub_id', dubClickIdQuery);
    const { referralContext, resolveReferralContext } = useAuthStore();

    const canonicalReferralCode = useMemo(
        () => shortReferralCode || referralCode || referralId || referralLinkId || referralAlias || '',
        [referralAlias, referralCode, referralId, referralLinkId, shortReferralCode],
    );
    const dubClickId = useMemo(() => queryDubClickId || getCookieValue('dub_id'), [queryDubClickId]);

    useEffect(() => {
        void resolveReferralContext({
            referralCode: canonicalReferralCode,
            dubClickId,
        });
    }, [canonicalReferralCode, dubClickId, resolveReferralContext]);

    return {
        dubClickId,
        referralCode: canonicalReferralCode,
        referralContext,
    };
};
